<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M14.51 4A1.5 1.5 0 0013 5.49V13H5.51a1.5 1.5 0 100 3H14a2 2 0 002-2V5.52A1.5 1.5 0 0014.52 4zM44 14.51A1.5 1.5 0 0042.5 13H35V5.51a1.5 1.5 0 10-3 0V14a2 2 0 002 2h8.5a1.51 1.51 0 001.5-1.49zM4 33.48A1.5 1.5 0 005.48 35H13v7.5a1.5 1.5 0 003 0V34a2 2 0 00-2-2H5.51A1.5 1.5 0 004 33.48zM42.49 32H34a2 2 0 00-2 2v8.5a1.5 1.5 0 003 0V35h7.5a1.5 1.5 0 000-3zM20 30h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2zm1-9h6v6h-6z"/></svg>